module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/settings-3-767942d81124579b13a4ff778be5503c.svg";